/* Practically Natty — storefront behaviour
 *
 * Everything data-driven reads from the DOM (data-* attributes and JSON script
 * tags written by the Liquid sections), so nothing here needs regenerating when
 * the merchant edits the theme.
 *
 *   1. legacy hero effects (guarded — they no-op on the vault home)
 *   2. scroll-driven stitch-out
 *   3. parallax + keycard tilt
 *   4. nav / quick-view / cart drawers on Shopify's AJAX cart API
 */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var money = function (cents) {
    return window.Shopify && window.Shopify.formatMoney
      ? window.Shopify.formatMoney(cents, window.SPLICE_MONEY_FORMAT)
      : "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
  };

  /* ---------------------------------------------------------------- boot */
  (function boot() {
    var box = $("#bootlog"), shell = $("#boot");
    if (!shell) return;
    if (reduce || sessionStorage.getItem("splice-booted")) {
      shell.classList.add("off");
      return;
    }
    sessionStorage.setItem("splice-booted", "1");
    var lines = [];
    try { lines = JSON.parse($("#boot-lines").textContent); } catch (e) { lines = []; }
    var i = 0, out = "";
    (function step() {
      if (i < lines.length) {
        out += lines[i++] + "<br>";
        box.innerHTML = out + '<span class="cursor"></span>';
        setTimeout(step, 200 + Math.random() * 130);
      } else {
        setTimeout(function () { shell.classList.add("off"); }, 420);
      }
    })();
    addEventListener("click", function () { shell.classList.add("off"); }, { once: true });
  })();

  /* ---------------------------------------------------------------- rain
     Glyphs that fall inside the PNP letterforms switch to the brand red and
     halve their speed, so the mark assembles itself out of the stream. The
     mask is sampled once per resize from the real vector. */
  (function matrix() {
    var cv = $("#rain");
    if (!cv) return;
    var ctx = cv.getContext("2d", { alpha: false });
    var GLYPH = ("アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロヲン" +
                 "PNP01234567890123456789").split("");
    var FS = 15, STEP = 1000 / 26;
    var W = 0, H = 0, cols = 0, drops = [], mask = null, mw = 0, mh = 0, dpr = 1, last = 0, live = true;
    var logo = new Image();
    logo.src = cv.dataset.mask || "";

    function buildMask() {
      if (!logo.complete || !logo.naturalWidth || !W) return;
      var m = document.createElement("canvas");
      mw = Math.max(1, Math.floor(W / 4));
      mh = Math.max(1, Math.floor(H / 4));
      m.width = mw; m.height = mh;
      var mc = m.getContext("2d");
      // must match .hero .ghost in the CSS: 46% wide, centred on 34% of height
      var tw = mw * 0.46, th = tw * (logo.naturalHeight / logo.naturalWidth);
      mc.drawImage(logo, (mw - tw) / 2, mh * 0.34 - th / 2, tw, th);
      // Reading pixels back can throw on a tainted canvas (some browsers do
      // this for file:// pages). The rain must keep falling either way.
      var d;
      try { d = mc.getImageData(0, 0, mw, mh).data; } catch (e) { mask = null; return; }
      mask = new Uint8Array(mw * mh);
      for (var i = 0, p = 3; i < mask.length; i++, p += 4) mask[i] = d[p] > 40 ? 1 : 0;
    }
    function inLogo(x, y) {
      if (!mask) return 0;
      var mx = x / 4 | 0, my = y / 4 | 0;
      if (mx < 0 || my < 0 || mx >= mw || my >= mh) return 0;
      return mask[my * mw + mx];
    }
    function size() {
      var r = cv.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = r.width; H = r.height;
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.fillStyle = "#04060a"; ctx.fillRect(0, 0, W, H);
      cols = Math.ceil(W / FS);
      drops = [];
      for (var i = 0; i < cols; i++) drops.push(Math.random() * -H);
      buildMask();
    }
    function frame(t) {
      requestAnimationFrame(frame);
      if (!live || t - last < STEP) return;
      last = t;
      ctx.fillStyle = "rgba(4,6,10,.085)";
      ctx.fillRect(0, 0, W, H);
      ctx.font = FS + "px 'STMono', monospace";
      ctx.textBaseline = "top";
      for (var i = 0; i < cols; i++) {
        var x = i * FS, y = drops[i];
        var g = GLYPH[Math.random() * GLYPH.length | 0];
        var hot = inLogo(x, y);
        if (hot) {
          ctx.fillStyle = "rgba(255,120,140,.95)";
          ctx.shadowColor = "#c8102e"; ctx.shadowBlur = 12;
        } else {
          ctx.fillStyle = Math.random() < .06 ? "#d9ffe6" : "rgba(57,255,106,.82)";
          ctx.shadowColor = "#39ff6a";
          ctx.shadowBlur = Math.random() < .06 ? 10 : 0;
        }
        ctx.fillText(g, x, y);
        ctx.shadowBlur = 0;
        // glyphs slow inside the letterforms, so the mark stays legible
        drops[i] = y > H && Math.random() > .975 ? -FS * 2 : y + (hot ? FS * 0.5 : FS);
      }
    }
    addEventListener("resize", size, { passive: true });
    logo.onload = buildMask;
    size();
    requestAnimationFrame(frame);
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) { live = es[0].isIntersecting; }, { threshold: .02 }).observe(cv);
    }
  })();

  /* ---------------------------------------------------------------- stitch
     Scroll drives an embroidery head along the REAL letterform paths. The same
     three paths are the mask stroke that reveals the mark, the dashed overlay
     that makes the revealed part read as stitches, and the needle's track.
     Specs come from the section's blocks in the DOM, not from this file. */
  (function stitch() {
    var svg = $("#stitchsvg");
    if (!svg) return;
    var wrap = $(".stitchwrap"), bar = $("#stitchbar"), sub = $("#stitchsub");
    var needle = $("#needle");
    var reveal = $$(".reveal", svg), lines = $$(".stitch", svg), done = $$(".done", svg);
    var items = $$("#joblog li");
    if (!reveal.length) return;

    var lens = reveal.map(function (p) { return p.getTotalLength(); });
    var total = lens.reduce(function (a, b) { return a + b; }, 0);
    reveal.forEach(function (p, i) {
      p.style.strokeDasharray = lens[i];
      p.style.strokeDashoffset = lens[i];
    });

    var ticking = false, prog = 0;

    function paint() {
      // walk the sequence: each letter finishes before the next one starts
      var run = prog * total, active = null, head = 0;
      reveal.forEach(function (p, i) {
        var drawn = Math.max(0, Math.min(lens[i], run));
        p.style.strokeDashoffset = lens[i] - drawn;
        lines[i].style.opacity = drawn > 0 ? .5 : 0;
        // a moving stroke can't cover tight interior corners, so a filled copy
        // switches on the moment a letter is complete
        done[i].setAttribute("opacity", drawn >= lens[i] ? 1 : 0);
        if (drawn > 0 && drawn < lens[i] && active === null) { active = p; head = drawn; }
        run -= lens[i];
      });

      if (active) {
        var pt = active.getPointAtLength(head);
        needle.setAttribute("cx", pt.x);
        needle.setAttribute("cy", pt.y);
        needle.setAttribute("opacity", 1);
      } else {
        needle.setAttribute("opacity", 0);
      }

      if (bar) bar.style.width = (prog * 100).toFixed(1) + "%";
      items.forEach(function (li, k) {
        li.classList.toggle("on", prog > (k + 0.6) / (items.length + 1));
      });
      if (sub && items.length) {
        var idx = Math.min(items.length - 1, Math.floor(prog * items.length));
        var cur = items[idx];
        sub.textContent = prog < 0.02 ? (sub.dataset.idle || "")
          : prog > 0.985 ? "Piece complete — " + items.length + " specs logged"
          : cur.querySelector("b").textContent + " — " +
            cur.textContent.replace(cur.querySelector("b").textContent, "").trim();
      }
    }
    function onScroll() {
      var r = wrap.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      prog = Math.min(1, Math.max(0, -r.top / (span || 1)));
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { paint(); ticking = false; });
      }
    }
    addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  })();

  /* ---------------------------------------------------------------- parallax */
  (function parallax() {
    var img = $("#wallimg"), sec = $(".gwall");
    if (!img || !sec || reduce) return;
    addEventListener("scroll", function () {
      var r = sec.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
      img.style.transform = "translateY(" + (-p * 54).toFixed(1) + "px)";
    }, { passive: true });
  })();

  /* ---------------------------------------------------------------- keycard */
  (function tilt() {
    var c = $("#keycard");
    if (!c) return;
    var holo = c.querySelector(".holo");
    c.parentElement.addEventListener("pointermove", function (e) {
      var r = c.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      c.style.transform = "rotateX(" + (-y * 13).toFixed(2) + "deg) rotateY(" + (x * 17).toFixed(2) + "deg)";
      if (holo) holo.style.setProperty("--holo", (x * 46).toFixed(1) + "%");
    });
    c.parentElement.addEventListener("pointerleave", function () {
      c.style.transform = "rotateX(0) rotateY(0)";
      if (holo) holo.style.setProperty("--holo", "0%");
    });
  })();

  /* ---------------------------------------------------------------- cart
     Real Shopify AJAX cart. Quick-add pulls the product JSON so a size can be
     chosen without leaving the grid; everything else posts straight to
     /cart/add.js, /cart/change.js and re-renders from /cart.js. */
  (function store() {
    var overlay = $("#overlay"), pdp = $("#pdp"), cartD = $("#cart"), toast = $("#toast");
    var navD = $("#navdrawer"), navBtn = $("#navopen");
    if (!overlay) return;
    var current = null, chosen = null, lastFocus = null;

    function openD(el) {
      lastFocus = document.activeElement;
      overlay.classList.add("open");
      el.classList.add("open");
      if (el === navD && navBtn) navBtn.setAttribute("aria-expanded", "true");
      var first = el.querySelector("a,button");
      if (first) first.focus({ preventScroll: true });
    }
    function closeAll() {
      overlay.classList.remove("open");
      if (pdp) pdp.classList.remove("open");
      if (cartD) cartD.classList.remove("open");
      if (navD) navD.classList.remove("open");
      if (navBtn) navBtn.setAttribute("aria-expanded", "false");
      if (lastFocus && lastFocus.focus) { lastFocus.focus({ preventScroll: true }); lastFocus = null; }
    }
    overlay.onclick = closeAll;
    $$("[data-close]").forEach(function (b) { b.onclick = closeAll; });
    addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });

    /* Mobile nav. A link inside the drawer navigates away, so nothing has to be
       torn down — but close on click anyway for in-page anchors. */
    if (navBtn && navD) {
      navBtn.onclick = function (e) { e.preventDefault(); openD(navD); };
      $$("a", navD).forEach(function (a) { a.addEventListener("click", closeAll); });
    }

    function flash(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add("show");
      setTimeout(function () { toast.classList.remove("show"); }, 1600);
    }

    /* ---- quick view ---- */
    $$("[data-quick]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        fetch("/products/" + btn.dataset.quick + ".js")
          .then(function (r) { return r.json(); })
          .then(function (p) {
            current = p;

            /* Withheld from this drop — visible, not purchasable.
               Two sources, matching snippets/withheld.liquid exactly: the card
               carries data-withheld (Liquid already resolved the settings handle
               list), and the product's own tags are re-checked here so a piece
               tagged in admin is honoured without a theme deploy. The quick view
               posts straight to /cart/add.js, so leaving this ungated would make a
               product unbuyable on its page and buyable from the drawer. */
            var withheld = btn.dataset.withheld === "1" ||
              (p.tags || []).some(function (t) { return String(t).toLowerCase() === "exclusive"; });

            var img = p.featured_image || (p.images && p.images[0]) || "";
            $("#pdp-img").src = img;
            $("#pdp-img").alt = p.title;
            $("#pdp-name").textContent = p.title;
            /* Tags double as the colourway line, so control tags must not leak
               into copy the customer reads. `available-now` is the offender that
               matters: on a withheld piece the drawer printed it directly under
               "Not in this drop" — the storefront contradicting itself in two
               adjacent lines. */
            var CONTROL_TAGS = ["exclusive", "available-now"];
            $("#pdp-cw").textContent = (p.tags || []).filter(function (t) {
              return CONTROL_TAGS.indexOf(String(t).toLowerCase()) === -1;
            }).join(" · ");
            $("#pdp-pr").textContent = money(p.price);
            $("#pdp-spec").textContent = (p.description || "").replace(/<[^>]+>/g, "").slice(0, 220);

            var sizes = $("#pdp-sizes");
            var addBtnEl = $("#pdp-add");
            var note = $("#pdp-withheld");

            if (withheld) {
              /* chosen stays null: #pdp-add's handler already returns early
                 without it, so even a re-enabled button cannot post. */
              chosen = null;
              if (sizes) { sizes.innerHTML = ""; sizes.hidden = true; }
              if (addBtnEl) addBtnEl.hidden = true;
              if (note) note.hidden = false;
            } else {
              if (note) note.hidden = true;
              if (sizes) sizes.hidden = false;
              if (addBtnEl) addBtnEl.hidden = false;
              var avail = p.variants.filter(function (v) { return v.available; });
              chosen = (avail[Math.min(2, avail.length - 1)] || p.variants[0]);
              $("#pdp-sizes").innerHTML = p.variants.map(function (v) {
                return '<button aria-pressed="' + (v.id === chosen.id) + '" data-v="' + v.id + '"' +
                       (v.available ? "" : " disabled") + ">" + v.title + "</button>";
              }).join("");
              $$("#pdp-sizes button").forEach(function (sb) {
                sb.onclick = function () {
                  chosen = p.variants.filter(function (v) { return String(v.id) === sb.dataset.v; })[0];
                  $$("#pdp-sizes button").forEach(function (x) {
                    x.setAttribute("aria-pressed", x === sb);
                  });
                };
              });
            }

            var link = $("#pdp-full");
            if (link) link.href = "/products/" + p.handle;
            openD(pdp);
          })
          .catch(function () { location.href = "/products/" + btn.dataset.quick; });
      });
    });

    var addBtn = $("#pdp-add");
    if (addBtn) addBtn.onclick = function () {
      if (!chosen) return;
      addBtn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: chosen.id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { closeAll(); refresh(true); flash("Added to cart"); })
        .catch(function () { flash("Could not add — try the product page"); })
        .then(function () { addBtn.disabled = false; });
    };

    /* ---- drawer ---- */
    function render(cart) {
      var n = $("#cartn"); if (n) n.textContent = cart.item_count;
      var box = $("#cart-lines");
      if (!box) return;
      if (!cart.items.length) {
        box.innerHTML = '<div class="empty">Empty — go get something heavy.</div>';
      } else {
        box.innerHTML = cart.items.map(function (l, i) {
          return '<div class="cline">' +
            '<img src="' + (l.image || "") + '" alt="" width="56" height="56">' +
            '<span><span class="nm">' + l.product_title + "</span><br>" +
            '<span class="sz">' + l.variant_title + " · " + money(l.price) + "</span></span>" +
            '<span class="qty">' +
              '<button data-line="' + (i + 1) + '" data-q="' + (l.quantity - 1) + '" aria-label="Remove one">−</button>' +
              l.quantity +
              '<button data-line="' + (i + 1) + '" data-q="' + (l.quantity + 1) + '" aria-label="Add one">+</button>' +
            "</span></div>";
        }).join("");
        $$(".qty button", box).forEach(function (b) {
          b.onclick = function () {
            b.disabled = true;
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.q })
            }).then(function (r) { return r.json(); }).then(render);
          };
        });
      }
      var sub = $("#subtotal");
      if (sub) sub.textContent = money(cart.total_price);
      var free = +(document.body.dataset.freeShip || 0) * 100;
      var meter = $("#meterbar"), note = $("#meternote");
      if (meter && free) meter.style.width = Math.min(100, cart.total_price / free * 100) + "%";
      if (note && free) {
        note.textContent = cart.total_price >= free
          ? "Free shipping unlocked"
          : money(free - cart.total_price) + " away from free shipping";
      }
    }
    /* Cart sweeper — the last line the STOREFRONT can draw.
       ------------------------------------------------------------------
       The product page renders no buy form and the quick view renders no add
       button, but neither of those is a lock: /cart/add.js is a public endpoint
       and Shopify accepts any variant that has stock. Verified, not assumed — a
       direct POST for a withheld variant returned 200 with the line in the cart.

       So if a withheld line is ever in the cart, take it back out and say so.
       This still cannot stop someone who posts to /cart/add.js and then walks
       straight to /checkout, because checkout is Shopify's, not the theme's.
       ⚠️ THE actual lock is inventory: qty 0 + policy `deny` on those products.
       Do not mistake this function for that. */
    function sweepWithheld(cart) {
      var list = window.PN_WITHHELD || [];
      if (!list.length || !cart || !cart.items || !cart.items.length) return Promise.resolve(cart);
      var bad = cart.items.filter(function (l) {
        return list.indexOf(String(l.handle).toLowerCase()) !== -1;
      });
      if (!bad.length) return Promise.resolve(cart);
      /* Remove by line KEY, never by index: indexes shift as lines are removed,
         so removing two would take the wrong second line. */
      return bad.reduce(function (chain, line) {
        return chain.then(function () {
          return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          }).then(function (r) { return r.json(); });
        });
      }, Promise.resolve()).then(function (c) {
        flash("Removed — not available in this drop");
        return c;
      });
    }

    function refresh(open) {
      return fetch("/cart.js").then(function (r) { return r.json(); })
        .then(sweepWithheld)
        .then(function (c) {
          render(c);
          if (open) openD(cartD);
        });
    }
    var opener = $("#cartopen");
    if (opener) opener.onclick = function (e) { e.preventDefault(); refresh(true); };
    refresh(false);
  })();
})();
